import { DropResult } from "react-beautiful-dnd";

import { BACK_BUTTON_ROLE } from "@constants/index";

import { addItemInList, removeItemFromList } from ".";

// Helpers PURS extraits verbatim de handleOnDragEndEvent (DragList/index.tsx)
// pour réduire la taille / complexité cyclomatique de cette god function, SANS
// changer le comportement. Chaque helper reçoit le clone local des pages + le
// DropResult et renvoie le nouvel objet pages ; les setters (@store) restent
// dans le composant. La logique interne (cycles remove/add, recalculs d'index,
// ternaires d'offset +1) est conservée à l'identique — ne pas "simplifier".

// Bloc "informationModes déplacé dans ways" : déplace informationModes puis
// resynchronise informationModesConsommation pour qu'il suive.
export function moveInformationModesWithinWays(
    localPagesItems: ItemsPagesType,
    result: DropResult
): ItemsPagesType {
    let data: ItemsPagesType = { ...localPagesItems };

    const [removedElement1, newSourceList1] = removeItemFromList(
        Object.values(data["ways"]),
        result.source.index
    );

    const removedItem1 = { ...removedElement1 };

    removedItem1.prefix = "ways";

    data["ways"] = Object.assign(
        {},
        ...newSourceList1.map((element) => ({
            [element.name]: { ...element },
        }))
    );

    const destinationList1 = Object.values(data["ways"]);

    let newDestinationList1 = addItemInList(
        destinationList1,
        result.destination!.index,
        removedItem1
    ) as PageType[];

    data["ways"] = Object.assign(
        {},
        ...newDestinationList1.map((element, index: number) => ({
            [element.name]: {
                ...element,
                index: index,
            },
        }))
    );

    let newLocalPageItem: ItemsPagesType = {
        ...data,
    };
    const informationModesConsommationIndex = Object.keys(
        newLocalPageItem.ways
    ).indexOf("informationModesConsommation");

    const informationModeNewIndex = Object.keys(
        newLocalPageItem.ways
    ).indexOf("informationModes");

    const [removedElement, newSourceList] = removeItemFromList(
        Object.values(newLocalPageItem["ways"]),
        informationModesConsommationIndex
    );

    const removedItem = { ...removedElement };

    removedItem.prefix = "ways";

    newLocalPageItem["ways"] = Object.assign(
        {},
        ...newSourceList.map((element) => ({
            [element.name]: { ...element },
        }))
    );

    const destinationList = Object.values(newLocalPageItem["ways"]);

    let newDestinationList = addItemInList(
        destinationList,
        informationModeNewIndex,
        removedItem
    ) as PageType[];

    newLocalPageItem["ways"] = Object.assign(
        {},
        ...newDestinationList.map((element, index: number) => ({
            [element.name]: {
                ...element,
                index: index,
            },
        }))
    );

    return newLocalPageItem;
}

// Bloc "connection ajouté depuis elements" : déplace connection vers ways puis
// auto-injecte authenticationModes et loyaltyConsommation.
export function moveConnectionWithAuthAndLoyalty(
    localPagesItems: ItemsPagesType,
    result: DropResult
): ItemsPagesType {
    let data: ItemsPagesType = { ...localPagesItems };

    const [removedElement1, newSourceList1] = removeItemFromList(
        Object.values(data["elements"]),
        result.source.index
    );

    const removedItem1 = { ...removedElement1 };

    removedItem1.prefix = "ways";

    data["elements"] = Object.assign(
        {},
        ...newSourceList1.map((element) => ({
            [element.name]: { ...element },
        }))
    );

    const destinationList1 = Object.values(data["ways"]);

    let newDestinationList1 = addItemInList(
        destinationList1,
        result.destination!.index,
        removedItem1
    ) as PageType[];

    data["ways"] = Object.assign(
        {},
        ...newDestinationList1.map((element, index: number) => ({
            [element.name]: {
                ...element,
                index: index,
            },
        }))
    );

    let newLocalPageItem: ItemsPagesType = {
        ...data,
    };
    const authenticationModesIndex = Object.keys(
        newLocalPageItem.elements
    ).indexOf("authenticationModes");

    const [removedElement, newSourceList] = removeItemFromList(
        Object.values(newLocalPageItem["elements"]),
        authenticationModesIndex
    );

    const removedItem = { ...removedElement };

    removedItem.prefix = "ways";

    newLocalPageItem["elements"] = Object.assign(
        {},
        ...newSourceList.map((element) => ({
            [element.name]: { ...element },
        }))
    );

    const destinationList = Object.values(newLocalPageItem["ways"]);

    let newDestinationList = addItemInList(
        destinationList,
        result.destination!.index + 1,
        removedItem
    ) as PageType[];

    newLocalPageItem["ways"] = Object.assign(
        {},
        ...newDestinationList.map((element, index: number) => ({
            [element.name]: {
                ...element,
                index: index,
            },
        }))
    );
    let newData: ItemsPagesType = { ...newLocalPageItem };
    let loyaltyConsommationIndex = Object.keys(newData.elements).indexOf(
        "loyaltyConsommation"
    );

    const [removedElement2, newSourceList2] = removeItemFromList(
        Object.values(newData["elements"]),
        loyaltyConsommationIndex
    );

    const removedItem2 = { ...removedElement2 };

    removedItem2.prefix = "ways";

    newData["elements"] = Object.assign(
        {},
        ...newSourceList2.map((element) => ({
            [element.name]: { ...element },
        }))
    );

    const destinationList2 = Object.values(newData["ways"]);
    const orderTakingIndex = Object.keys(newData.ways).indexOf("orderTaking");
    const authenticationModesNewIndex = Object.keys(newData.ways).indexOf(
        "authenticationModes"
    );

    let newDestinationList2 = addItemInList(
        destinationList2,
        authenticationModesNewIndex > orderTakingIndex
            ? authenticationModesNewIndex + 1
            : orderTakingIndex + 1,
        removedItem2
    ) as PageType[];

    newData["ways"] = Object.assign(
        {},
        ...newDestinationList2.map((element, index: number) => ({
            [element.name]: {
                ...element,
                index: index,
            },
        }))
    );

    return newData;
}

// Bloc "authenticationModes ajouté depuis elements" : déplace authenticationModes
// vers ways puis auto-injecte loyaltyConsommation.
export function moveAuthModesWithLoyalty(
    localPagesItems: ItemsPagesType,
    result: DropResult
): ItemsPagesType {
    let data: ItemsPagesType = { ...localPagesItems };

    const [removedElement1, newSourceList1] = removeItemFromList(
        Object.values(data["elements"]),
        result.source.index
    );

    const removedItem1 = { ...removedElement1 };

    removedItem1.prefix = "ways";

    data["elements"] = Object.assign(
        {},
        ...newSourceList1.map((element) => ({
            [element.name]: { ...element },
        }))
    );

    const destinationList1 = Object.values(data["ways"]);

    let newDestinationList1 = addItemInList(
        destinationList1,
        result.destination!.index,
        removedItem1
    ) as PageType[];

    data["ways"] = Object.assign(
        {},
        ...newDestinationList1.map((element, index: number) => ({
            [element.name]: {
                ...element,
                index: index,
            },
        }))
    );

    let newData: ItemsPagesType = { ...data };
    let loyaltyConsommationIndex = Object.keys(newData.elements).indexOf(
        "loyaltyConsommation"
    );

    const [removedElement2, newSourceList2] = removeItemFromList(
        Object.values(newData["elements"]),
        loyaltyConsommationIndex
    );

    const removedItem2 = { ...removedElement2 };

    removedItem2.prefix = "ways";

    newData["elements"] = Object.assign(
        {},
        ...newSourceList2.map((element) => ({
            [element.name]: { ...element },
        }))
    );

    const destinationList2 = Object.values(newData["ways"]);
    const orderTakingIndex = Object.keys(newData.ways).indexOf("orderTaking");
    const authenticationModesIndex = Object.keys(newData.ways).indexOf(
        "authenticationModes"
    );

    let newDestinationList2 = addItemInList(
        destinationList2,
        result.destination!.index > orderTakingIndex
            ? result.destination!.index + 1
            : authenticationModesIndex > orderTakingIndex
            ? authenticationModesIndex + 1
            : orderTakingIndex + 1,
        removedItem2
    ) as PageType[];

    newData["ways"] = Object.assign(
        {},
        ...newDestinationList2.map((element, index: number) => ({
            [element.name]: {
                ...element,
                index: index,
            },
        }))
    );

    return newData;
}

// Bloc "informationModes ajouté depuis elements" : déplace informationModes vers
// ways puis auto-injecte informationModesConsommation juste après.
export function addInformationModesWithConsommation(
    localPagesItems: ItemsPagesType,
    result: DropResult
): ItemsPagesType {
    let data: ItemsPagesType = { ...localPagesItems };

    const [removedElement1, newSourceList1] = removeItemFromList(
        Object.values(data["elements"]),
        result.source.index
    );

    const removedItem1 = { ...removedElement1 };

    removedItem1.prefix = "ways";

    data["elements"] = Object.assign(
        {},
        ...newSourceList1.map((element) => ({
            [element.name]: { ...element },
        }))
    );

    const destinationList1 = Object.values(data["ways"]);

    let newDestinationList1 = addItemInList(
        destinationList1,
        result.destination!.index,
        removedItem1
    ) as PageType[];

    data["ways"] = Object.assign(
        {},
        ...newDestinationList1.map((element, index: number) => ({
            [element.name]: {
                ...element,
                index: index,
            },
        }))
    );

    let newLocalPageItem: ItemsPagesType = {
        ...data,
    };
    const informationModesConsommationIndex = Object.keys(
        newLocalPageItem.elements
    ).indexOf("informationModesConsommation");

    const [removedElement, newSourceList] = removeItemFromList(
        Object.values(newLocalPageItem["elements"]),
        informationModesConsommationIndex
    );

    const removedItem = { ...removedElement };

    removedItem.prefix = "ways";

    newLocalPageItem["elements"] = Object.assign(
        {},
        ...newSourceList.map((element) => ({
            [element.name]: { ...element },
        }))
    );

    const destinationList = Object.values(newLocalPageItem["ways"]);

    let newDestinationList = addItemInList(
        destinationList,
        result.destination!.index + 1,
        removedItem
    ) as PageType[];

    newLocalPageItem["ways"] = Object.assign(
        {},
        ...newDestinationList.map((element, index: number) => ({
            [element.name]: {
                ...element,
                index: index,
            },
        }))
    );

    return newLocalPageItem;
}

// Bloc "informationModes retiré de ways" : déplace informationModes vers elements
// puis retire informationModesConsommation en cascade. NB : ce bloc mute
// localPagesItems en place (comportement d'origine conservé) ; il lit aussi la
// sourceList calculée dans le composant.
export function removeInformationModesCascade(
    localPagesItems: ItemsPagesType,
    result: DropResult,
    sourceList: PageType[]
): ItemsPagesType {
    const [removedElement, newSourceList] = removeItemFromList(
        sourceList,
        result.source.index
    );
    const removedItem = { ...removedElement };

    removedItem.prefix = result.destination!.droppableId;

    localPagesItems[result.source.droppableId] = Object.assign(
        {},
        ...newSourceList.map((element) => ({
            [element.name]: { ...element },
        }))
    );

    const destinationList = Object.values(
        localPagesItems[result.destination!.droppableId]
    );

    const newDestinationList = addItemInList(
        destinationList,
        result.destination!.index,
        removedItem
    ) as PageType[];

    localPagesItems[result.destination!.droppableId] = Object.assign(
        {},
        ...newDestinationList.map((element, index: number) => ({
            [element.name]: { ...element, index: index },
        }))
    );

    const newLocalPagesItems1: ItemsPagesType = {
        ...localPagesItems,
    };
    const informationModesConsommationIndex = Object.keys(
        newLocalPagesItems1.ways
    ).includes("informationModesConsommation")
        ? Object.keys(newLocalPagesItems1.ways).indexOf(
              "informationModesConsommation"
          )
        : -1;

    if (informationModesConsommationIndex !== -1) {
        const [removedElement, newSourceList] = removeItemFromList(
            Object.values(newLocalPagesItems1["ways"]),
            informationModesConsommationIndex
        );

        const removedItem = { ...removedElement };

        removedItem.prefix = "elements";

        newLocalPagesItems1["ways"] = Object.assign(
            {},
            ...newSourceList.map((element) => ({
                [element.name]: { ...element },
            }))
        );

        const destinationList = Object.values(
            newLocalPagesItems1["elements"]
        );

        let newDestinationList = addItemInList(
            destinationList,
            informationModesConsommationIndex,
            removedItem
        ) as PageType[];

        newLocalPagesItems1["elements"] = Object.assign(
            {},
            ...newDestinationList.map((element, index: number) => ({
                [element.name]: {
                    ...element,
                    index: index,
                },
            }))
        );
    }
    return newLocalPagesItems1;
}

// Bloc "printerOptions déplacé juste avant finalMessage" : double effet — déplace
// printerOptions ET désactive son bouton "Back". Renvoie les pages + les items du
// bouton à désactiver (null s'il n'y a pas de bouton "Back"). Le composant
// applique les deux setters dans l'ordre d'origine.
export function movePrinterOptionsBeforeFinalMessage(
    localPagesItems: ItemsPagesType,
    result: DropResult
): {
    data: ItemsPagesType;
    backButtonItems: ActionsButtonsDesignItemType[] | null;
} {
    let data: ItemsPagesType = { ...localPagesItems };
    const [removedElement1, newSourceList1] = removeItemFromList(
        Object.values(data["ways"]),
        result.source.index
    );

    const removedItem1 = { ...removedElement1 };

    removedItem1.prefix = "ways";

    data["ways"] = Object.assign(
        {},
        ...newSourceList1.map((element) => ({
            [element.name]: { ...element },
        }))
    );

    const destinationList1 = Object.values(data["ways"]);

    let newDestinationList1 = addItemInList(
        destinationList1,
        result.destination!.index,
        removedItem1
    ) as PageType[];

    data["ways"] = Object.assign(
        {},
        ...newDestinationList1.map((element, index: number) => ({
            [element.name]: {
                ...element,
                index: index,
            },
        }))
    );

    const filteredItems = (data.ways
        .printerOptions as PageType).actionsButtons.items.filter(
        (item: ActionsButtonsDesignItemType) => {
            const ROLES = [BACK_BUTTON_ROLE];

            return ROLES.includes(item.role);
        }
    );
    const findIndex = filteredItems.find((element) => element.name === "Back");

    if (findIndex) {
        const actionButtonItem = filteredItems.indexOf(findIndex);

        filteredItems[actionButtonItem] = {
            ...findIndex,
            active: false,
        };

        return { data, backButtonItems: filteredItems };
    }

    return { data, backButtonItems: null };
}
